<template>
  <div class="redPackage-audit">
    <!-- <div class="head-wrap">
        <img class="avatar" src="@/assets/avatar.png" alt="">
        <div class="welcome">
            <div class="user">早上好，{{username}}</div>
            <div class="to-do">今天待审核单量共有<span class="num">{{ total }}</span>单，开始工作吧</div>
        </div>
    </div> -->
    <div class="audit-wrap">
      <div class="title">审核视窗</div>
      <el-row class="warning-wrap">
        <div class="warning-item" v-for="(item, index) in list" :key="index">
          <div class="state">{{ item.title }}</div>
          <div
            style="
              position: absolute;
              top: 15px;
              right: 15px;
              color: #333333 !important;
            "
            @click="handleScreen(index)"
          >
            筛选 >
          </div>
          <div class="number flex-column">
            <div class="flex">
              <img :src="item.imgSrc" alt="" />
              <div class="content">
                <span class="value">{{ getNum(item.key) }}</span>
                <span class="label">剩余单量</span>
              </div>
            </div>
            <el-button
              :disabled="getNum(item.key) == 0"
              @click="handleToDone(item.key)"
              class="btn"
              type="primary"
              size="small"
              >立即处理</el-button
            >
          </div>
        </div>
        <!-- <div class="warning-item">
                <div class="state">昨日待处理</div>
                <div class="number flex-column">
                    <div class="flex">
                    <img src="https://imgcdn.hemiao100.com/static/yesterday.png" alt="">
                    <div class="content">
                        <span class="value">{{getNum("B")}}</span>
                        <span class="label">剩余单量</span>
                    </div>
                    </div>
                    <el-button class="btn" type="primary" size="small">立即处理</el-button>
                </div>
            </div>
            <div class="warning-item">
                <div class="state">今日待处理</div>
                <div class="number flex-column">
                    <div class="flex">
                    <img src="https://imgcdn.hemiao100.com/static/today.png" alt="">
                    <div class="content">
                        <span class="value">{{getNum("C")}}</span>
                        <span class="label">剩余单量</span>
                    </div>
                    </div>
                    <el-button class="btn" type="primary" size="small">立即处理</el-button>
                </div>
            </div>
            <div class="warning-item">
                <div class="state">重新分配单</div>
                <div class="number flex-column">
                    <div class="flex">
                    <img src="https://imgcdn.hemiao100.com/static/distr-icon.png" alt="">
                    <div class="content">
                        <span class="value">{{getNum("D")}}</span>
                        <span class="label">剩余单量</span>
                    </div>
                    </div>
                    <el-button class="btn" type="primary" size="small">立即处理</el-button>
                </div>
            </div> -->
      </el-row>
    </div>





    <div class="audit-box">
      <div class="audit-wrap">
        <div class="audit-head">
          <div class="title">
            余额预警
            <span class="audit-head-text">近15天有申报单 余额低于下限</span>
          </div>

          <div class="right-warp">
            <div class="circular-box">
              <div class="circular" style="background: #FF7A00"></div>
              <div class="circular-text">余额不足</div>
            </div>
            <div class="circular-box" style="margin-left: 20px">
              <div class="circular" style="background: #949494"></div>
              <div class="circular-text">长期不发</div>
            </div>
          </div>
        </div>

        <div class="audit-list">
          <audit-card
            class="audit-card"
            v-if="withMaxDeclareTimestampList.length > 0"
            v-for="(item, index) in withMaxDeclareTimestampList"
            :key="index"
            :title="item.store_name"
            :money="item.account_balance_money"
            :iconType="item.iconType"
            isNumber = "0"
          ></audit-card>
        </div>
      </div>

      <div class="audit-wrap other-wrap">
        <div class="audit-head">
          <div class="title">挂起</div>
          <div class="right-warp">
            <div class="circular-box">
              <div class="circular" style="background: #E50065"></div>
              <div class="circular-text">挂起</div>
            </div>
          </div>
        </div>

        <div class="audit-list">
          <audit-card
            class="audit-card"
            v-if="obtainDataList.length > 0"
            v-for="(item, index) in obtainDataList"
            :title="item.store_name"
            :iconType="3"
            :key="index"
            :num="item.declare_sn_num"
            :lastTime="item.last_time"
            isNumber = "1"
          ></audit-card>
        </div>
      </div>


      <div class="audit-wrap other-wrap">
        <div class="audit-head">
          <div class="title">已转供应商待审单量</div>
          <div class="right-warp">
            <div class="circular-box">
              <div class="circular" style="background: #EA2121"></div>
              <div class="circular-text">待审核</div>
            </div>
          </div>
        </div>

        <div class="audit-list">
          <audit-card
            class="audit-card"
            v-if="accountWaitBillStatList.length > 0"
            v-for="(item, index) in accountWaitBillStatList"
            :title="item.storeName"
            :iconType="4"
            :key="index"
            :code="item.storeCode"
            :num="item.declareSnNum"
            :startDeclareTime="item.startDeclareTime"
            :endDeclareTime="item.endDeclareTime"
            :lastTime="item.lastTime"
            isNumber = "2"
          ></audit-card>


        </div>
      </div>


    </div>

    <el-dialog
      title="筛选"
      :visible.sync="addVisible"
      width="940px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleDialogClose"
      destroy-on-close
    >
      <el-form ref="addForm" :model="addForm" label-width="100px">
        <el-form-item label="单据类型" prop="type">
          <el-radio-group v-model="addForm.type">
            <el-radio label="month">月结单</el-radio>
            <el-radio label="normal">普通单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关联省份">
          <hm-base-transfer
            ref="provinceTransfer"
            leftName="可选权益"
            rightName="已选权益"
            :leftOption="leftOption"
            :leftProps="leftProps"
            :rightProps="leftProps"
            compareKey="code"
          ></hm-base-transfer>
        </el-form-item>
        <el-form-item label="关联供货商">
          <div>
            <el-input
              v-model="keyWords"
              class="mr20"
              clearable
              placeholder="请输入供货商名称"
            ></el-input
            ><el-button @click="queryList" type="primary">查询</el-button>
          </div>
          <hm-base-transfer
            ref="providerTransfer"
            leftName="可选权益"
            rightName="已选权益"
            :leftOption="leftOption2"
            :leftProps="leftProps2"
            :rightProps="leftProps2"
            compareKey="storeCode"
          ></hm-base-transfer>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="handledistrConfirm" type="primary" size="small"
          >确定</el-button
        >
        <el-button @click="addVisible = false" size="small">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { getLoginUser } from "@/utils/auth";
import HmBaseTransfer from "@/components/HmBaseTransfer";
import AuditCard from "../components/audit-card";
export default {
  name: "",
  components: { HmBaseTransfer, AuditCard },
  mixins: [],
  data() {
    return {
      accountWaitBillStatList:[],
      obtainDataList:[],
      withMaxDeclareTimestampList: [],
      planUrgencyLevelWaitBillStat: [],
      total: 0,
      username: "",
      addForm: {
        type: "",
        province: "",
        provider: "",
      },
      addVisible: false,
      // 省份
      leftProps: [
        {
          name: "省份",
          value: "name",
        },
      ],
      leftOption: [],
      provinceList: [],

      leftProps2: [
        {
          name: "供货商名称",
          value: "name",
        },
      ],
      leftOption2: [],
      allSupplier: [],
      keyWords: "",
      accountList: {},
      row: {},
      memos: [],
      billStatList: [],
      type: "",
      nextQuery: {},
      list: [
        {
          title: "已逾期",
          imgSrc: "https://imgcdn.hemiao100.com/static/delay.png",
          key: "A",
        },
        {
          title: "昨日待处理",
          imgSrc: "https://imgcdn.hemiao100.com/static/yesterday.png",
          key: "B",
        },
        {
          title: "今日待处理",
          imgSrc: "https://imgcdn.hemiao100.com/static/today.png",
          key: "C",
        },
        {
          title: "重新分配单",
          imgSrc: "https://imgcdn.hemiao100.com/static/distr-icon.png",
          key: "D",
        },
      ],
    };
  },
  created() {
    const userInfo = getLoginUser();
    this.username = userInfo.username;
    this.initData();
    this.obtainData();
    this.queryAccountWaitBillStat();
  },
  mounted() {
    this.querySupplierBalanceWarningList();
  },
  methods: {
    /**
     * @desc 获取表格数据
     */
    initData() {
      this.$store
        .dispatch("queryAccountRemainBillStat", {
          account: this.username,
        })
        .then((res) => {
          const tableData = res.result.records;
          console.log("---tableData---:", tableData);
          console.log(tableData[0].planUrgencyLevelWaitBillStat);
          this.total = 0;
          this.planUrgencyLevelWaitBillStat =
            tableData[0].planUrgencyLevelWaitBillStat.map((item) => {
              this.total += item.billNum;
              return item;
            });
        });
    },
    //获取余额预警
    querySupplierBalanceWarningList() {
      this.$store
        .dispatch("querySupplierBalanceWarningList", {
          username: this.username,
        })
        .then((res) => {
          res.result.withMaxDeclareTimestamp.forEach(
            (v) => (v.iconType = 1)
          );
          res.result.withoutMaxDeclareTimestamp.forEach(
            (v) => (v.iconType = 2)
          );
          this.withMaxDeclareTimestampList = [...res.result.withMaxDeclareTimestamp, ...res.result.withoutMaxDeclareTimestamp];
          
        
        });
    },
    //获取供应商单量
    obtainData(){
        this.$store
        .dispatch("obtainData", {
          ew:{
            username: this.username,
          },
          templateCode:'supplier_balance_hang'
        })
        .then((res) => {
           this.obtainDataList=res.result
        });
    },
    // 获取已转供应商待审单量
    queryAccountWaitBillStat(){
      this.$store
        .dispatch("queryAccountWaitBillStat", {
          account: this.username,
        })
        .then((res) => {
          this.accountWaitBillStatList = res.result;
        })
    },
    handleDialogClose() {
      this.addVisible = false;
    },
    //筛选提交
    handledistrConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const province = this.$refs.provinceTransfer.rightChecked;
          const provider = this.$refs.providerTransfer.rightChecked;
          console.log(province, provider);
          let params = {
            planId: this.row.plan_id,
            // adjustingOperId: this.row.alloc_oper_id,
            adjustingWorkId: this.addForm.accountName,
            adjustingBillTypeList: [this.addForm.type],
            adjustingProvinceCodeList: province.map((item) => item.code),
            adjustingSupplierCodeList: provider.map((item) => item.code),
          };
          if (!this.addForm.type) {
            delete params.adjustingBillTypeList;
          }
          if (
            !params.adjustingProvinceCodeList ||
            !params.adjustingProvinceCodeList.length
          ) {
            delete params.adjustingProvinceCodeList;
          }
          if (
            !params.adjustingSupplierCodeList ||
            !params.adjustingSupplierCodeList.length
          ) {
            delete params.adjustingSupplierCodeList;
          }
          console.log(params);
          this.nextQuery = {
            adjustingSupplierCodeList: params.adjustingSupplierCodeList,
            adjustingProvinceCodeList: params.adjustingProvinceCodeList,
            adjustingBillTypeList: params.adjustingBillTypeList,
            planUrgencyLevel: this.type,
            pathFrom: "audit",
          };
          this.$store
            .dispatch("queryAccountRemainBillStat", {
              adjustingSupplierCodeList: params.adjustingSupplierCodeList,
              adjustingProvinceCodeList: params.adjustingProvinceCodeList,
              adjustingBillTypeList: params.adjustingBillTypeList,
              account: this.username,
              planUrgencyLevel: this.type,
            })
            .then((res) => {
              const tableData = res.result.records;
              console.log("---tableData---:", tableData);
              console.log(tableData[0].planUrgencyLevelWaitBillStat);
              // this.total = 0;
              if (this.type == "A") {
                this.planUrgencyLevelWaitBillStat[0] =
                  tableData[0].planUrgencyLevelWaitBillStat[0];
              } else if (this.type == "B") {
                this.planUrgencyLevelWaitBillStat[1] =
                  tableData[0].planUrgencyLevelWaitBillStat[0];
              } else if (this.type == "C") {
                this.planUrgencyLevelWaitBillStat[2] =
                  tableData[0].planUrgencyLevelWaitBillStat[0];
              } else if (this.type == "D") {
                this.planUrgencyLevelWaitBillStat[3] =
                  tableData[0].planUrgencyLevelWaitBillStat[0];
              }
              // this.planUrgencyLevelWaitBillStat = tableData[0].planUrgencyLevelWaitBillStat.map(
              //   (item) => {
              //     this.total += item.billNum;
              //     return item;
              //   }
              // );
              console.log(this.planUrgencyLevelWaitBillStat, "数据列表");
              if (res.code == 0) {
                this.addVisible = false;
                this.$message({
                  message: "筛选成功",
                  type: "success",
                });
                this.addForm = {
                  type: "",
                  province: "",
                  provider: "",
                };
              }
            });
        }
      });
    },
    handleScreen(index) {
      console.log(index);
      if (index == 0) {
        this.type = "A";
      } else if (index == 1) {
        this.type = "B";
      } else if (index == 2) {
        this.type = "C";
      } else if (index == 3) {
        this.type = "D";
      }
      this.leftOption = [];
      this.leftOption2 = [];
      this.allSupplier = [];
      let params = {
        allocWorkId: this.username,
      };
      //获取供应商信息
      this.$store.dispatch("queryAllsupply", params).then((res) => {
        console.log("供应商-->", res);
        const { provinceWorkStatList, suppliereWorkStatList } = res.result;
        this.leftOption = provinceWorkStatList;
        this.leftOption2 = suppliereWorkStatList;
        this.allSupplier = suppliereWorkStatList;
      });
      this.addVisible = true;
    },
    queryList() {
      this.leftOption2 = this.allSupplier.filter(
        (item) => item.name.indexOf(this.keyWords) > -1
      );
    },
    getNum(key) {
      const item = this.planUrgencyLevelWaitBillStat.find(
        (item) => item.planUrgencyLevel === key
      );
      // console.log('key-->',key,'单数-->',item.billNum)
      return item ? parseInt(item.billNum) : 0;
    },
    handleToDone(key) {
      console.log(key, this.nextQuery);
      this.nextQuery.pathFrom = "audit";
      this.$router.push({
        path: `/guiderCommission/auditList/detailsSalesVolumeNew2?planUrgencyLevel=${key}`,
        query: this.nextQuery,
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.redPackage-audit {
  // padding: 30px;
  background: #f4f4f4;
  min-height: calc(100vh - 220px);
  .head-wrap {
    width: 100%;
    height: 221px;
    // background: linear-gradient(358deg, #f71e7e 0%, #f664a4 100%);
    background: url("../../../assets/head-bg.png") no-repeat center;
    background-size: cover;
    border-radius: 16px 16px 16px 16px;
    padding: 0 80px;
    margin-bottom: 30px;
    display: flex;
    // justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .avatar {
      width: 98px;
      height: 98px;
      border: 2px solid #ffffff;
      border-radius: 50%;
      margin-right: 30px;
    }
    .welcome {
      font-family: PingFang SC, PingFang SC;
      color: #ffffff;
      .user {
        // height: 39px;
        font-weight: 600;
        font-size: 28px;
        line-height: 39px;
        margin-bottom: 15px;
      }
      .to-do {
        // height: 35px;
        font-weight: 500;
        font-size: 16px;
        line-height: 35px;
        .num {
          font-size: 24px;
        }
      }
    }
  }

  .audit-box {
    display: flex;
    margin-top: 20px;

    & > div {
      flex: 1;
    }
    .other-wrap {
      margin-left: 10px;
    }
  }
  .audit-head {
    display: flex;
    justify-content: space-between;
    .audit-head-text {
      font-size: 14px;
      color: #222222;
    }
  }
  .audit-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .audit-card {
      width: 49%;
      margin-bottom: 10px;
    }
  }

  .right-warp {
    display: flex;
    align-items: flex-start;

    .circular-box {
      display: flex;
      justify-content: center;
      align-items: center;
      .circular {
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }
      .circular-text {
        margin-left: 10px;
        font-size: 12px;
      }
    }
  }

  .audit-wrap {
    background: #ffffff;
    padding: 20px;
    .title {
      height: 22px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #222222;
      line-height: 19px;
      margin-bottom: 20px;
      position: relative;
      &::before {
        content: "";
        display: inline-block;
        width: 3px;
        height: 14px;
        margin-right: 7px;
        background: #e50065;
        border-radius: 2px 0px 2px 0px;
        vertical-align: middle;
      }
    }
    .warning-wrap {
      display: flex;
      .warning-item {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 381px;
        height: 160px;
        padding: 15px;
        margin-right: 19px;
        border-radius: 8px 8px 8px 8px;
        border: 4px solid #e33e3e;
        border-bottom: unset;
        border-left: unset;
        border-right: unset;
        color: #ffb74f;
        border-color: #ffb74f;
        background: #fff3ec;
        &:first-of-type {
          color: #e33e3e;
          border-color: #e33e3e;
          background: #ffeef0;
        }
        &:nth-of-type(2) {
          .el-button--primary {
            background: #ff8e4f;
            border-color: #ff8e4f;
          }
        }
        &:nth-of-type(3) {
          color: #00a870;
          border-color: #00a870;
          background: #ebfff8;
          .el-button--primary {
            background: #20b382;
            border-color: #20b382;
          }
        }
        &:last-of-type {
          margin-right: 0;
          color: #0094a8;
          border-color: #0094a8;
          background: #e8fcff;
          .el-button--primary {
            background: #0094a8;
            border-color: #0094a8;
          }
        }
        .el-button--primary.is-disabled {
          opacity: 0.6;
        }
        .state {
          position: absolute;
          position: absolute;
          top: 15px;
          left: 15px;
        }

        .number {
          display: flex;
          align-items: center;
          img {
            width: 70px;
            height: 70px;
            margin-right: 20px;
          }

          .content {
            display: flex;
            flex-direction: column;
            .value {
              width: 53px;
              height: 52px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 44px;
              // color: #e33e3e;
              color: rgba(0, 0, 0, 0.9);
              line-height: 52px;
            }
            .label {
              height: 22px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: rgba(0, 0, 0, 0.6);
              line-height: 19px;
            }
          }
          .btn {
            width: 100%;
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
